'use client';
import type { FC } from 'react';
import { ButtonNextLink } from '~/app/_components/button';
import { routes } from '~/utils/routes';
import { VipOnlyModalContainer } from '@app/_containers/vip-only-modal-container';
import { useLocalHooks } from './use-local-hooks';
type Props = {
  storyId: string;
};

export const VipOnlyStoryButtonContainer: FC<Props> = ({ storyId }) => {
  const { onClickHandler, isShowVipOnlyModal, closeVipOnlyModal } =
    useLocalHooks();

  return (
    <>
      <ButtonNextLink
        marginTop="16px"
        marginBottom="8px"
        href={routes.story.url(storyId)}
        onClick={onClickHandler}
      >
        作品ページ
      </ButtonNextLink>
      <VipOnlyModalContainer
        isOpen={isShowVipOnlyModal}
        storyId={storyId}
        onClose={closeVipOnlyModal}
      />
    </>
  );
};
